import React from "react";
import { observer } from "mobx-react";
import { reconnectLiSequenceLoadingPopupState } from "./ReconnectLiSequenceLoadingPopupState";

const ReconnectLiSequenceLoadingPopup = observer(() => {
  const closePopup = () => {
    reconnectLiSequenceLoadingPopupState.setShowPopup(false);
  };

  if (!reconnectLiSequenceLoadingPopupState.showPopup) {
    return null;
  }

  return (
    <div className="popupWrapper reconnectSequenceLoadingPopupWrapper">
      <div className="reconnect-sequence-loading-popup common-popup">
        <i
          className="material-icons reconnect-sequence-loading-close"
          onClick={closePopup}
        >
          close
        </i>
        <div
          data-id="reconnect-li-sequence-loading-popup"
          className="popup-wrap reconnectSequenceLoadingPopup"
        >
          <div className="reconnect-sequence-loading-header">
            <h3 className="reconnect-sequence-loading-title">Please wait...</h3>
          </div>

          <div className="reconnect-sequence-loading-content">
            <p className="reconnect-sequence-loading-message">
              Reconnecting the LinkedIn account to selected sequences…
            </p>
            <p className="reconnect-sequence-loading-submessage">
              Reactivating affected contacts. Please wait.
            </p>

            <div className="reconnect-sequence-loading-progress">
              <div className="reconnect-sequence-loading-progress-bar">
                <div className="reconnect-sequence-loading-progress-fill"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="confirmation-popup-mask" onClick={closePopup} />
    </div>
  );
});

export default ReconnectLiSequenceLoadingPopup;
export { ReconnectLiSequenceLoadingPopup };
